export class News {
    title:string | undefined;
    subTitle:string | undefined;
    info:string | undefined;
    url:string | undefined;
    order:string | undefined;
    type:string | undefined;
    lang:string | undefined;
    country:string | undefined;
    createDate:Date |undefined;
}
